<template>
	<div class="encode-as-abc">
		<speaker-notes :notes="currentNotes"></speaker-notes>
		<h2>Implementation - Encoding</h2>
		<flow-chart selected="encode"></flow-chart>
		<code :class="`abc p1 ${part === 1 ? 'open' : 'closed'}`">
			X:1<br>
			T:Twinkle, Twinkle<br>
			M:4/4<br>
			L:1/4<br>
			Q:1/4=180<br>
			K:Bb<br>
			<span class="b1">"Bb"BBff|</span>"Eb"gg"Bb"f2|"Eb"ee"Bb"dd|"F7"cc"Bb"B2|]
		</code>
		<music-display :abc="twinkle" :has-audio="false" :large="true" :class="`p${part}`"></music-display>

		<code class="p2" v-if="part === 2" v-html="musicMap"></code>
	</div>
</template>

<script>
	import PageParts from "../helpers/page-parts";
	import FlowChart from "../components/FlowChart";
	import SpeakerNotes from "../components/SpeakerNotes";
	import { mapGetters } from 'vuex';
	import MusicDisplay from "../components/MusicDisplay";
	import {formatMusic} from "../helpers/format-music";
	export default {
		name: "encode-as-abc",
		components: {MusicDisplay, SpeakerNotes, FlowChart},
		mixins: [
			PageParts,
		],
		computed: {
			musicMap() {
				const map = this.simpleMusicMap().replace(/\n/g, '<br>').replace(/ /g, '&nbsp;');
				return map.replace(/<b2>/g,'<span class="b2">');
			}
		},
		data() {
			return {
				twinkle: formatMusic(this.simpleMusicAbbrev()),
				notes: [
					[
						"Here is the input for Twinkle.",
						"I won't get into the details of the ABC format.",
						"The last line is where the music is.",
						"In the quotes there is a chord name, then the notes are letters.",
						"A capital letter is one octave and a small letter is the next octave up.",
						"So let's turn that into an array of note events.",
					], [
						"Two tracks, one for melody and one for accompaniment.",
						"The pitches are the midi standard numbers.",
						"The instrument is one of 127 standard midi instruments.",
						"The start and end times are in measures.",
						"The end time doesn't go all the way to the next start time.",
						"That is translated at the last minute to a tempo. That allows for quick tempo changes.",
						"The volumes are also from the MIDI standard.",
					]
				],
			};
		},
		methods: {
			...mapGetters(['simpleMusic', 'simpleMusicAbbrev', 'simpleMusicMap']),
		},
	}
</script>

<style lang="scss" scoped>
	.encode-as-abc {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	code {
		margin-top: 20px;
	}
	.abc {
		overflow: hidden;
		transition: max-height .5s ease-in-out;
		&.closed {
			max-height: 0;
			padding: 0;
			margin: 0;
		}
		&.open {
			max-height: 400px;
		}
	}
</style>

<style lang="scss">
	.encode-as-abc .p1 {
		.abcjs-m1, .abcjs-m2, .abcjs-m3 {
			fill: $gray-music;
		}
	}
</style>
